/**
 * Cart rewards: Focal theme (cart-drawer + openable-element modals).
 * Theme settings: window.themeCartRewards.autoOpenFreeProduct (from cart-rewards-progress snippet).
 */
(() => {
  if (!window.customElements.get("cart-rewards-progress")) {
    window.customElements.define(
      "cart-rewards-progress",
      class extends HTMLElement {
        connectedCallback() {
          this.setAttribute("data-cart-rewards-ready", "");
        }
      }
    );
  }

  function openModalBySelector(selector) {
    const el = document.querySelector(selector);
    if (el && "open" in el) {
      el.open = true;
      return true;
    }
    return false;
  }

  document.addEventListener(
    "click",
    (event) => {
      const trigger = event.target.closest("[data-cart-rewards-open]");
      if (!trigger) return;
      const sel = trigger.getAttribute("data-cart-rewards-open");
      if (!sel) return;
      event.preventDefault();
      openModalBySelector(sel);
    },
    false
  );

  /**
   * After cart events / drawer open, the theme often re-renders line items on the next tick.
   * queueMicrotask runs too early for that; a short macrotask delay lets DOM + data-cart-total
   * catch up before we read product ids / subtotal for auto-open.
   */

  function scheduleMaybeAutoOpenFreeProductModal() {
    setTimeout(() => {
      void maybeAutoOpenFreeProductModal();
    }, 1000);
  }

  function cartSubtotalUnitsFromDom() {
    const el = document.querySelector("[data-cart-rewards-subtotal]");
    if (!el) return null;
    const cents = parseInt(el.getAttribute("data-cart-total-value"), 10);
    if (Number.isNaN(cents)) return null;
    return cents / 100;
  }

  function productIdsInCartFromDom() {
    const ids = new Set();
    document.querySelectorAll("line-item[data-product-id]").forEach((node) => {
      const id = node.getAttribute("data-product-id");
      if (id) ids.add(String(id));
    });
    document.querySelectorAll("[data-js-cart-item][data-product-id]").forEach((node) => {
      const id = node.getAttribute("data-product-id");
      if (id) ids.add(String(id));
    });
    return ids;
  }

  async function refreshCartProductIdsIfNeeded() {
    const fromDom = productIdsInCartFromDom();
    if (fromDom.size > 0) return fromDom;
    try {
      const root = window.Shopify?.routes?.root || "/";
      const res = await fetch(`${root}cart.js`, { credentials: "same-origin" });
      if (!res.ok) return fromDom;
      const cart = await res.json();
      const ids = new Set();
      (cart.items || []).forEach((item) => {
        if (item.product_id != null) ids.add(String(item.product_id));
      });
      return ids;
    } catch {
      return fromDom;
    }
  }

  function isCartSurfaceOpen() {
    const drawer = document.getElementById("mini-cart");
    if (drawer && drawer.hasAttribute("open")) return true;
    return Boolean(document.getElementById("main-cart-page"));
  }

  async function maybeAutoOpenFreeProductModal() {
    if (!window.themeCartRewards?.autoOpenFreeProduct) return;
    if (!isCartSurfaceOpen()) return;

    const subtotal = cartSubtotalUnitsFromDom();
    if (subtotal == null) return;
    console.log("subtotal", subtotal);

    const inCart = await refreshCartProductIdsIfNeeded();
    const root = document.querySelector("cart-rewards-progress");
    if (!root) return;
    console.log("root", root);
    const milestones = root.querySelectorAll('[data-type="free_product"][data-tier]');
    console.log("milestones", milestones);
    for (const ms of milestones) {
      const threshold = parseFloat(ms.getAttribute("data-threshold") || "0");
      if (subtotal + 1e-9 < threshold) continue;

      const raw = ms.getAttribute("data-product-ids") || "";
      if (!raw.trim()) continue;

      const tierIds = raw
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const anyInCart = tierIds.some((id) => inCart.has(String(id)));
      const productInCart = ms.getAttribute("data-product-in-cart") === "true";
      if (anyInCart || productInCart) continue;

      const tier = ms.getAttribute("data-tier");
      if (!tier) continue;
      const tierOpenedKey = `freeProductAutoOpened${tier}`;
      if (localStorage.getItem(tierOpenedKey) === "1") continue;

      console.log("tier", tier);
      console.log("anyInCart", anyInCart);
      console.log("productInCart", productInCart);

      if (openModalBySelector(`#cart-rewards-modal-tier-${tier}`)) {
        localStorage.setItem(tierOpenedKey, "1");
      }
      break;
    }
  }

  document.documentElement.addEventListener("cart:updated", () => {
    scheduleMaybeAutoOpenFreeProductModal();
  });

  document.documentElement.addEventListener("cart:refresh", () => {
    scheduleMaybeAutoOpenFreeProductModal();
  });

  document.addEventListener("openable-element:open", (event) => {
    if (event.target && event.target.id === "mini-cart") {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart-popup-opened", { bubbles: true })
      );
      scheduleMaybeAutoOpenFreeProductModal();
    }
  });

  document.documentElement.addEventListener("cart-popup-opened", () => {
    scheduleMaybeAutoOpenFreeProductModal();
  });

  document.documentElement.addEventListener("cart-opened", () => {
    scheduleMaybeAutoOpenFreeProductModal();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      scheduleMaybeAutoOpenFreeProductModal();
    });
  } else {
    scheduleMaybeAutoOpenFreeProductModal();
  }
})();
